import { WabunkaExperienceGuestTypeBasedPrice } from '@japan-culture-and-technology/wabunka-protos/ts_proto/wabunka_experience_guest_type_based_price';

import { useCurrency } from '@/wabunka-src/common/composables/general/useCurrency/useCurrency';
import { useFetchToPublicWabunkaApi } from '@/wabunka-src/common/composables/query/useFetchToPublicWabunkaApi';
import { buildExperiencePreReservationPriceCalculateWithGuestTypeRequest, buildExperiencePreReservationPriceWithGuestTypeViewModel } from '@/wabunka-src/features/Experience';
import type { WabunkaReservationWithGuestTypeForm } from '@/wabunka-src/features/Experience';

/**
 * 料金テーブルの計算（ゲストを考慮）
 */
export const useWabunkaExperiencePreReservationPriceCalculationsWithGuests = () => {
  const { selectedCurrency } = useCurrency();
  const calculate = async (form: Ref<WabunkaReservationWithGuestTypeForm>, currency?: string) => {
    const path = ref(`/experienceEvents/${form.value.experienceEvent.id}/calculatePrice`);
    const resolvedCurrency = currency ?? selectedCurrency.value;

    // Nuxt 4 では同じ key のキャッシュが共有されるため、呼び出し毎にユニークな key を生成して
    // 常に最新の guest counts で再計算させる（POST のレスポンスをキャッシュすると古い料金が返る）
    const uniqueKey = `${path.value}-${resolvedCurrency}-${Date.now()}-${Math.random().toString(36).slice(2)}`;

    const { data, error, status, execute, refresh } = await useFetchToPublicWabunkaApi({
      path,
      key: uniqueKey,
      body: ref(buildExperiencePreReservationPriceCalculateWithGuestTypeRequest(form.value, false, resolvedCurrency)),
      method: ref('POST'),
      options: { server: false },
      converter: WabunkaExperienceGuestTypeBasedPrice.fromJSON,
    });

    const preReservationPrice = computed(() => (data.value ? buildExperiencePreReservationPriceWithGuestTypeViewModel(data.value) : undefined));
    return { preReservationPrice, error, status, execute, refresh };
  };

  return { calculate };
};
